const REGISTRATION_SETTINGS_URL = `/api/v1/users/register/settings`;

const fetchRegistrationSettings = async () => {
  const response = await fetch(REGISTRATION_SETTINGS_URL, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  const data = await response.json();
  return data.status.code === 200 ? data : undefined;
};

export const OnboardingApi = {
  getSettings: fetchRegistrationSettings,
};
